import { SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';

/**
 * This is exclusively used within the merch card components.
 * It is used to display the product icon and the title of the merch card.
 *
 * @param ProductIcon - The product icon to display.
 * @param Title - The title of the merch card. Should be a FormattedMessage component.
 * @returns A flex container with the product icon and the title of the merch card.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MerchCardTitleContainer = ({
  Title,
  Badge
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [Badge, /*#__PURE__*/_jsx(SectionTitle, {
      children: Title
    })]
  });
};